const ACTION_SYNONYMS: Record<string, string[]> = {
  list: ['list', 'show'], // TODO: Need to confirm is show is allowed with list or with read
  read: ['read', 'show'],
  create: ['create'],
  update: ['edit', 'update'],
  delete: ['delete'],
};

// Helper function to format Casbin action groups
export function formatCasbinActionGroup(actions: Record<string, boolean>): string {
  const allowedActions: string[] = [];
  Object.keys(actions).forEach((action) => {
    if (!actions[action]) return;
    (ACTION_SYNONYMS[action] ?? [action]).forEach((a) => allowedActions.push(a));
  });
  // Use ^ and $ anchors to ensure exact action matches
  // Without anchors, regex like (update) would match update_accommodations
  return allowedActions.length > 0 ? `^(${allowedActions.join('|')})$` : '';
}

// Helper function to generate Casbin RBAC policies
export function generateCasbinRBACPolicies(
  role: string,
  permissions: Record<string, Record<string, boolean>>
): string {
  const policyLines: string[] = [];

  for (const [resource, actions] of Object.entries(permissions)) {
    const formattedActions = formatCasbinActionGroup(actions);

    if (formattedActions) {
      const resources = resource.endsWith('s') ? resource : `${resource}s`;
      policyLines.push(`p, ${role}, ${resources}, ${formattedActions}`);
      policyLines.push(`p, ${role}, ${resources}/*, ${formattedActions}`);
    }
  }

  // console.log('policyLines ===>', policyLines);
  return policyLines.join('\n');
}

// // Helper function to check if experience has started
// export function hasExperienceStarted(experience: any): boolean {
//   const experienceStartTime = experience?.settings?.start_time;

//   if (!experienceStartTime) {
//     return true; // If no start time is set, consider it as started
//   }

//   try {
//     const scheduledStartTime = new Date(experienceStartTime);
//     const currentDateTime = new Date();
//     const hasStarted = currentDateTime >= scheduledStartTime;

//     return hasStarted;
//   } catch (error) {
//     console.error('Error parsing experience start time:', error);
//     return true; // Default to true if there's an error parsing the date
//   }
// }
